module.exports = __webpack_public_path__ + "static/organicblackswirl-fe3b2563261a8a6293ee36521b7e4ed1.jpeg";